import { Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import * as Chart from 'chart.js';

@Component({
  selector: '',
  template: '',
})
export class BarChartHandler implements OnInit {
  @Input() chartData: any;
  @Input() chartOptions: any;
  @Input() chartType: string;
  @Input() chartPlugins: any[];
  @Input() labels: string[] = [];
  @Input() datasets: any[] = [];
  @Input() chartTitle: string = '';

  constructor(public service: DashboardService) {}

  ngOnInit() {
    this.service.addRoundedBars(Chart);
  }

  @ViewChild('barChartCanvas') chartCanvas: ElementRef;

  chartInstance: any;

  ngAfterViewInit() {
    this.renderChart();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes['chartData'] || changes['chartOptions']) && this.chartCanvas) {
      this.renderChart();
    }
  }

  renderChart() {
    if (!this.chartCanvas || !this.chartCanvas.nativeElement) return;

    if (this.chartInstance) {
      this.chartInstance.destroy();
    }

    if (!this.chartData || !this.chartData.labels || !this.chartData.datasets) return;

    this.chartInstance = new Chart(this.chartCanvas.nativeElement, {
      type: this.chartType,
      data: this.chartData,
      options: this.chartOptions,
      plugins: this.chartPlugins,
    });
  }

  ngOnDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
    this.service.clear();
  }
}
